import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../../../app.service';
import { UserService } from '../../../../../app/shared/services/user.service';
@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit {
    ShowAlertFiled: boolean = false;
  constructor(
    public readonly _router: Router,
    private readonly _app: AppService,private _user: UserService,) { }

  ngOnInit() {
    this._app.setPageTitle("Preferences");
      this.LoadShowAlertTab();
  }
 LoadShowAlertTab() {
        this._user.HasShowAlert().subscribe(roles => {
            if (roles) {
                this.ShowAlertFiled = roles;
            }

        })
    }
}
